$(document).ready(function () {
	$(document).on('scroll', function () {
		var id = "#" + $("section:in-viewport").attr('id');
		$('a[href^="#"]').each(function () {
			var target = this.hash;
			$(this).removeClass("active");

			if (target === id) {
				$(this).addClass("active");
			}
		});

		console.log();
	});
});
